export default "__VITE_ASSET__DSp1LX1m__"